import ProjectCard from "../components/projectcard"
import React from "react"


const Projects =(props)=>{
return(
  
  <div className="project-body">
    <ProjectCard name={'Video Game Progression tracker'} img={'https://i.imgur.com/6HKQTn3.png'}
    description={"An application built using the MERN stack and deployed on heroku. This app allows you to manually track the progress of 1 or multiple video games you may be playing or were playing."}
    github={'https://github.com/JwR513/Video-Game-completetion-app'} site={'https://fierce-hollows-06258.herokuapp.com'}
    />
    <ProjectCard name={'Workout Share'} img={'https://i.imgur.com/MbbZtNZ.png'}
    description={"A Web Application built using React and Typescript for the front-end and Express.js and PostgreSQL/Sequelize for the backend. This app alows you to create workout splits and add days to them how ever you see fit and shares them with other users of the site. "}
    github={'https://github.com/JwR513/WorkoutShare'} site={'https://jocular-squirrel-4bf2e0.netlify.app/'} />
    <ProjectCard name={'Group Finder'} img={'https://i.imgur.com/6ueE2XK.png'}
    description={"A Group project I helped create whilst attending General Assemblys SEI course. A PERN Stack application used to find a group to play a certain video game with."}
    github={'https://github.com/Skim1571/Group-Finder'} site={'https://group-finder-pro.herokuapp.com/'} />

  </div>
)
}

export default Projects